import { c as _c } from "react/compiler-runtime";
import { Heading, Image, TextLink, TextPassage } from '@petsmart-ui/sparky';
import './feature-card.scss';
export type FeatureCardModel = {
  description?: string;
  href: string;
  imageUrl: string;
  openInNewTab?: boolean;
  title: string;
};
type FeatureCardProps = {
  card: FeatureCardModel;
  onClick?: () => void;
};
export function FeatureCard(t0) {
  const $ = _c(14);
  const {
    card,
    onClick
  } = t0;
  const t1 = card.openInNewTab ? "noopener noreferrer" : undefined;
  const t2 = card.openInNewTab ? "_blank" : undefined;
  let t3;
  if ($[0] !== card.imageUrl) {
    t3 = <Image className="feature-card__image" src={card.imageUrl} alt="" />;
    $[0] = card.imageUrl;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== card.title) {
    t4 = <Heading className="feature-card__title" tagName="h3" size="body-bold">{card.title}</Heading>;
    $[2] = card.title;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== card.description) {
    t5 = card.description && <TextPassage className="feature-card__description" size="sm">{card.description}</TextPassage>;
    $[4] = card.description;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== card.href || $[7] !== onClick || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = <TextLink href={card.href} className="feature-card" onClick={onClick} rel={t1} target={t2}>{t3}{t4}{t5}</TextLink>;
    $[6] = card.href;
    $[7] = onClick;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}